export class Price {
    public value: number = null;
    public currencyCode: string = null;
    public currencySymbol: string = null;
}
